<template>
  <div class="home">
    <h1>主页面</h1>
    <p>token：{{token}}</p>
    <p>当前皮肤：{{curTheme}}</p>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'Home',
  data() {
    return {
    }
  },
  computed: {
    ...mapState('sys', ['token']),
    ...mapState('theme', ['curTheme']),
  }
}
</script>

<style lang='scss' scoped>
.home {
  padding: 20px;
  text-align: center;
  p {
    margin-bottom: 6px;
  }
}
</style>
